import type { Permission } from '@kdk/shared';
import type { AdminPage } from './adminPages';

export type NavItem = { to: string; label: string; section: string };

/** 各ページの Task で、ここに自分のメニューを追加する。表示順 = 配列順。 */
export const NAV_ITEMS: readonly NavItem[] = [
  { to: '/', label: 'ダッシュボード', section: '全体' },
  { to: '/cases', label: '案件・必要人数', section: '見える・管理できる' },
  { to: '/calendar', label: '配置カレンダー', section: '見える・管理できる' },
  { to: '/search', label: '配置候補検索', section: '見える・管理できる' },
  { to: '/master', label: '業務マスタ（分業区分）', section: '分業できる・余力を作る' },
  { to: '/simulation', label: '分業シミュレーション', section: '分業できる・余力を作る' },
  { to: '/schedule', label: '推進スケジュール', section: '推進' },
];

export const ADMIN_SECTION = '管理';

/** 基本のメニュー + 権限のある管理ページ(section「管理」)。権限のあるものが無ければ「管理」は出ない。 */
export const buildNavItems = (
  can: (permission: Permission) => boolean,
  adminPages: readonly AdminPage[],
): NavItem[] => [
  ...NAV_ITEMS,
  ...adminPages
    .filter((page) => can(page.permission))
    .map((page) => ({ to: `/admin/${page.path}`, label: page.label, section: ADMIN_SECTION })),
];
